// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3-RNN","badges":"styles_badges__3JQQ5"};